import BookingsDa from "./da/bookings";
import BookingsDe from "./de/bookings";
import BookingsEn from "./en/bookings";
import BookingsEs from "./es/bookings";
import BookingsFi from "./fi/bookings";
import BookingsFr from "./fr/bookings";
import BookingsHr from "./hr/bookings";
import BookingsIt from "./it/bookings";
import BookingsLt from "./lt/bookings";
import BookingsLv from "./lv/bookings";
import BookingsMe from "./me/bookings";
import BookingsNl from "./nl/bookings";
import BookingsPl from "./pl/bookings";
import BookingsSr from "./sr/bookings";
import BookingsSe from "./se/bookings";
import BookingsTr from "./tr/bookings";

export default {
  messages: {
    da:{bookings:BookingsDa},
    de:{bookings:BookingsDe},
    en:{bookings:BookingsEn},
    es:{bookings:BookingsEs},
    fi:{bookings:BookingsFi},
    fr:{bookings:BookingsFr},
    hr:{bookings:BookingsHr},
    it:{bookings:BookingsIt},
    lt:{bookings:BookingsLt},
    lv:{bookings:BookingsLv},
    me:{bookings:BookingsMe},
    mx:{bookings:BookingsEs},
    nl:{bookings:BookingsNl},
    pl:{bookings:BookingsPl},
    sr:{bookings:BookingsSr},
    se:{bookings:BookingsSe},
    tr:{bookings:BookingsTr},
  },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/bookings.js